var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"video",staticClass:"w-full h-full"},[_c('client-only',[_c('vimeo-player',{ref:"player",staticClass:"object-cover w-full h-full",attrs:{"video-id":_vm.component.vimeo_id,"autoplay":_vm.isActive,"player-width":_vm.width,"player-height":_vm.height,"loop":true,"options":_vm.playerOptions},on:{"ready":_vm.onReady}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }